import PlanGraph from "../../Components/PlanGraph/PlanGraph";
import { Grid2 } from "@mui/material";
import PlanUsageStyle from "./PlanUsageStyle.module.scss";
import UpcomingInvoice from "../../Components/UpcomingInvoice/UpcomingInvoice";
import Addon from "../../Components/Addon/Addon";
import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { accountIsAllEbs } from "../../../../../../Utils/roconConstants";
import { getStore } from "../../../../../../Utils/storeUtils";
import { Actions } from "../../../../../../redux/constants/actionTypes";
function PlanUsage(props) {
  const { upcomingInvoice, specificPlan, dedicatedHosting } = props;
  const { orgId } = useParams();
  const sitesList = useSelector((state) => state.sitesInfo?.sitesList?.data);
  // this section only lists v1 add-ons (Staging, Performance Sites, Additional Site):
  // hidden once the account has only v2 (EBS) sites
  const v2Account = accountIsAllEbs(orgId, sitesList);
  useEffect(() => {
    getStore().dispatch({
      type: Actions.API_SITES_LIST,
      data: { orgId: orgId ? orgId : -1 },
      meta: { onSuccess: () => {}, onError: () => {} },
    });
  }, [orgId]);

  const addonPlan = Array.isArray(specificPlan)
    ? specificPlan.filter((plan) => plan.basePlan === false)
    : [];

  const addonDataWithoutWaf = Array.isArray(specificPlan)
    ? specificPlan.filter(
        (plan) => plan.basePlan === false && plan?.licenseType !== "Waf"
      )
    : [];

  const baseSingleSitePlan = Array.isArray(specificPlan)
    ? specificPlan.filter(
        (plan) => plan.basePlan === true && plan.isSingleSite === true
      )
    : [];

  return (
    <Grid2 className={PlanUsageStyle.container}>
      <Grid2>
        <PlanGraph specificPlan={specificPlan} />
      </Grid2>

      {!dedicatedHosting && !v2Account && (
        <>
          <Grid2 className={PlanUsageStyle.headerLine}></Grid2>
          <Grid2 className={PlanUsageStyle.addon}>
            <Addon invoiceItems={addonPlan} addonData={addonDataWithoutWaf} />
          </Grid2>
        </>
      )}

      <Grid2 className={PlanUsageStyle.headerLine}></Grid2>
      <Grid2 className={PlanUsageStyle.invoice}>
        <UpcomingInvoice
          planPrice={upcomingInvoice?.basePlan?.price}
          additionalSitePrice="0.00"
          additionalSiteCount="0"
          WAFCount="1"
          WAFPrice="FREE"
          AddonCount="0"
          AddonPrice="0.00"
          TaxAmount={upcomingInvoice?.tax}
          estimatedBill={upcomingInvoice?.estimatedBill}
          singleSitePlan={baseSingleSitePlan?.[0]?.singleSite}
        />
      </Grid2>
    </Grid2>
  );
}

export default PlanUsage;
